import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/app.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Research from "./pages/Research";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import ProductDetail from "./pages/ProductDetail";
import NewsDetail from "./components/NewsDetail";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/haqqimizda" element={<About />} />
        <Route path="/mehsullar" element={<Products />} />
        <Route path="/mehsullar/:id" element={<ProductDetail />} />
        <Route path="/xeber/:id" element={<NewsDetail />} />
        <Route path="/tedqiqat" element={<Research />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/elaqe" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
